<template>
  <div>
    <div v-if="isPaySuccess" class="font-bold t-center fon-24 c-red">
        支付成功
    </div>
    <div v-else class="pa-tb-30">
      <div class="font-bold t-center fon-24 c-red">
        支付金额：<span >￥{{ Amount }}</span>
      </div>
      <div class="flex flex-direction f-center f-jcenter">
        <div id="qrcodeDiv"  class="ma-tb-20"></div>
        <div>微信扫码支付</div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { orderPay, PayResult } from "../api.js";
import QRCode from "qrcodejs2";

export default {
  props: {
    //支付的key
    payKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      Amount: "",
      Qrcode: "",
      PayId: "",
      interval: "",
      isPaySuccess:false
    };
  },
  created(){
    this.orderAdd();
  },
  methods: {
    //下单
    orderAdd() {
      orderPay({
        Key: this.payKey,
        Type: "weixin",
      }).then((res) => {
        console.log(res);
        this.Amount = res.data.Data.Amount;
        this.PayId = res.data.Data.PayId;
        this.Qrcode = res.data.Data.Qrcode;

        let qrcodeDiv = document.getElementById("qrcodeDiv");
        qrcodeDiv.innerHTML = "";
        var qrcode = new QRCode(qrcodeDiv, {
          text: "",
          width: 128,
          height: 128,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        qrcode.makeCode(this.Qrcode);

        this.getPayState();
      });
    },
    //监听支付结果
    getPayState() {
     var that=this
      this.interval = setInterval(() => {
        PayResult({ PayId: this.PayId }).then((result) => {
          if (result.data.Data) {
            this.isPaySuccess=true
            this.$message({
                message: "支付成功",
                type: "success",
            });
            // 支付成功后的回调函数
            that.$emit("paySuccess");
            clearInterval(this.interval);
          }
        });
      }, 1500);
    },
  },
  destroyed(){
    console.log('destroyed')
    clearInterval(this.interval);
  },
};
</script>
  
<style  lang="scss" scoped>
</style>